// import logo from './logo.svg';
import React, { useRef, useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';
import Header from '../components/Header';

import Sidebar from '../components/Sidebar';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { AiOutlineClose } from "react-icons/ai";

// Pantallas
import Inicio from '../screens/Inicio';
import Perfil from '../screens/Perfil';
import Aceptados from '../screens/Events/Aceptados';
import Creados from '../screens/Events/Creados';
import Login from '../screens/Login';
import Register from '../screens/Register';

// Importaciones para el modal
import { Button, Modal, Box, Typography, TextField, InputAdornment, Tabs, Tab, Grid, Divider, Checkbox, Switch, Card, Avatar, Fade, IconButton, Chip, Autocomplete } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material';

// Iconos
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

// Redux
import store from '../store';
import { EVENTMODAL_action, GUESTSMODAL_action } from '../store/actions/modalAction';
import { CREATE_EVENT_action } from '../store/actions/eventAction';

// Date y time pickers
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileTimePicker, StaticDateTimePicker, StaticTimePicker } from '@mui/x-date-pickers';


// Componentes de Material UI
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

// Componentes de JOY UI
import { AspectRatio, Input, Option, Textarea } from '@mui/joy';
import CreateEvent from '../screens/Events/CreateEvent';
import EventDetails from '../screens/Events/EventDetails';
import EditEvent from '../screens/Events/EditEvent';
import ResetPassword from '../screens/ResetPassword';
import Terms from '../screens/Terms';
import EventsMap from '../screens/Events/EventsMap';
import JuntadaComun from '../components/EventTypes/JuntadaComun';
import JuntadaComunDetails from '../components/EventTypes/JuntadaComunDetails';
import PrivatedEvents from '../screens/Events/PrivatedEvents';




const mapStateToProps = (state) => {
    return {
        page: state.pageReducer.pageName,
        user: state.userReducer,
        eventModalState: state.modalReducer.eventModalState,
        guestsModalState: state.modalReducer.guestsModalState
    }
}





const RoutesList = ({ user, eventModalState, guestsModalState }) => {
    const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive

    const [eventName, setEventName] = useState('')
    const [eventDescription, setEventDescription] = useState('')
    const eventDescRef = useRef(null)

    const [eventLocation, setEventLocation] = useState('')

    const [eventHour, setEventHour] = useState(null)
    const [traducedHour, setTraducedHour] = useState(null)

    const [selectedDate, setSelectedDate] = useState(null)
    const [traducedDate, setTraducedDate] = useState(null)

    const [eventCreator, setEventCreator] = useState('')

    const [indexEventType, setIndexEventType] = useState(0)
    let [eventType, setEventType] = useState('')

    const [eventDuration, setEventDuration] = useState(false)

    let [selectedGuest, setSelectedGuest] = useState()


    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const [file, setFile] = useState()

    const handleImageUpload = (e) => {
        setFile(e.target.files[0])
        // Guardar el archivo en el estado local o realizar otras operaciones
    };

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {

    }, []);

    return (
        <>
            <div style={{
                // backgroundColor: '#F6F6F6'
                // backgroundColor: 'white'
            }}>
                <Router>
                    <div>
                        <Routes>
                            <Route path="/" element={<Inicio />} exact />
                            <Route path="/inicio" element={<Inicio />} exact />
                            <Route path="/perfil" element={<Perfil />} exact />
                            <Route path="/aceptados" element={<Aceptados />} exact />
                            <Route path="/creados" element={<Creados />} exact />
                            <Route path="/login" element={<Login />} exact />
                            <Route path="/registro" element={<Register />} exact />
                            <Route path="/createevent" element={<CreateEvent />} exact />
                            <Route path="/editevent" element={<EditEvent />} exact />
                            <Route path="/event/:slug" element={<EventDetails />} exact />
                            <Route path="/reset-password" element={<ResetPassword />} exact />
                            <Route path="/terms&conditions" element={<Terms />} exact />
                            {/* <Route path="/mapa" element={<EventsMap />} exact /> */}
                            <Route path="/invitaciones" element={<PrivatedEvents />} exact />
                        </Routes>
                    </div>
                </Router>
            </div>



        </>
    );
}


export default connect(mapStateToProps)(RoutesList)




// DEMASIADOS RESULTADOS OBTENIDOS, INTENTE INGRESAR DATOS MAS PRECISOS
// La imagen no es obligatoria, al indicar qué tipo de evento quiere crear mas abajo, pondremos automaticamente una imagen en referencia al tipo de evento seleccionado